<template>
  <section>
    <section class="calc-box-container">
      <!-- 左侧 -->
      <div class="calc-box-left">
        <div class="text-box f-dir-c ai-center">
          <div class="label">
            {{
            isExternalFreight
            ? '外调车运费'
            : '承包价'
            }}
          </div>
          <div class="value">
            <input class="calc-chart-ipt"
                   type="text"
                   v-model="dispatchInfo.totalFee"
                   @blur="totalFeeChange()" />
          </div>
        </div>
        <div class="text-box f-dir-c ai-center"
             v-if="isExternalFreight">
          <div class="label">运费上限</div>
          <div class="value">
            {{ dispatchInfo.guidePrice ? dispatchInfo.guidePrice : 0 }}
          </div>
        </div>
      </div>
      <!-- 间隔线 -->
      <div class="calc-box-separate"></div>
      <!-- 右侧 -->
      <div class="calc-box-right">
        <div class="row-title">
          <span>
            预付总计（标准{{
            (dispatchInfo.preTotalScaleStandard * 100).toFixed(2)
            }}%）
          </span>
          <span>
            预付现金（标准{{
            (dispatchInfo.preCashScaleStandard * 100).toFixed(2)
            }}%）
          </span>
          <span>
            预付油卡（标准{{
            (dispatchInfo.preOilVirtualScaleStandard * 100).toFixed(2)
            }}%）
          </span>
          <span v-if="
              dispatchInfo.preEtcFee > 0 ||
              isContractPaymentWay
            ">
            ETC（标准{{
            (dispatchInfo.preEtcScaleStandard * 100).toFixed(2)
            }}%）
          </span>
        </div>
        <div class="calc-row">
          <div class="row-label">预付金额</div>
          <div class="row-content">
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preTotalFee"
                         readonly />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preTotalScale"
                         readonly />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">=</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preCashFee"
                         @blur="feeUpdate('CASH')" />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preCashScale"
                         @blur="scaleUpdate('CASH')" />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">+</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">虚拟油</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preOilVirtualFee"
                         @blur="feeUpdate('VIRTUAL')" />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preOilVirtualScale"
                         @blur="scaleUpdate('VIRTUAL')" />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">+</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">实体油</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preOilFee"
                         @blur="feeUpdate('OIL')" />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.preOilScale"
                         @blur="scaleUpdate('OIL')" />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <template v-if="
                dispatchInfo.preEtcFee > 0 ||
                isContractPaymentWay
              ">
              <div class="row-symbol">+</div>
              <div class="row-box">
                <div class="text-box ai-center">
                  <div class="label">金额</div>
                  <div class="value">
                    <input class="calc-chart-ipt"
                           type="text"
                           v-model="dispatchInfo.preEtcFee"
                           @blur="feeUpdate('ETC')" />
                  </div>
                </div>
                <div class="text-box ai-center">
                  <div class="label">比例</div>
                  <div class="value">
                    <input class="calc-chart-ipt"
                           type="text"
                           v-model="dispatchInfo.preEtcScale"
                           @blur="scaleUpdate('ETC')" />
                    <span class="calc-chart-unit">%</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="calc-row">
          <div class="row-label">到付金额</div>
          <div class="row-content">
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.arrivePaymentFee"
                         @blur="feeUpdate('ARRIVE_CASH')" />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.arrivePaymentFeeScale"
                         @blur="scaleUpdate('ARRIVE_CASH')" />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="calc-row">
          <div class="row-label">尾款金额</div>
          <div class="row-content">
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.finalFee"
                         readonly />
                </div>
              </div>
              <div class="text-box ai-center">
                <div class="label">比例</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.finalScale"
                         readonly />
                  <span class="calc-chart-unit">%</span>
                </div>
              </div>
            </div>
            <div class="row-symbol">=</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">现金</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.finalCashFee"
                         readonly />
                </div>
              </div>
            </div>
            <div class="row-symbol">+</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">保费</div>
                <div class="value">
                  <input class="calc-chart-ipt"
                         type="text"
                         v-model="dispatchInfo.insuranceFee"
                         readonly />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <qx-custom-form v-show="dispatchInfo.preOilVirtualFee"
                    :noSubBtn="true"
                    ref="baseForm"
                    :formData="baseForm"
                    labelWidth="120px"></qx-custom-form>
    <button @click="getDataTest"
            class="test-btn">测试提交参数</button>
  </section>
</template>

<script>
import {
  getLevel,
  getAmountLimitCfgVal,
} from 'api/operate';
import {
  isExist,
  isTwoBitDecimal,
} from '@qx/utils/index';
export default {
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    isNeedBill: {
      type: Number,
      default: 0,
    },
    paymentWay: {
      type: Number,
      default: 0,
    },
    appointWay: {
      type: Number,
      default: 3,
    },
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '分配油来源',
            value: 'oilAccountType',
            type: 'select',
            default: '1',
            options: [
              { label: '本车队定点油', value: '1' },
              { label: '找油-无发票', value: '2' },
              { label: '找油-有发票', value: '3' },
            ],
            onChange: () => {
              this.oilAccountTypeChange();
            },
          },
        ],
      },
      // 会员权益
      LevelInfo: {},
      // 下面是本组件要提交的参数
      dispatchInfo: {
        // 这个要，但是好像暂时没用
        isNeedBill: 0,
        // 这个要
        appointWay: 3,
        // 这个要
        paymentWay: 0,
        // 这个要
        vehicleClass: 0,
        // 这个要
        maxAmount: 0,
        // 这两个要，但是不知道干嘛的
        feeList: [],
        // feeTitle: '',
        // 下面是要显示的

        // 外调车运费/承包价
        totalFee: 0,
        // 运费上限
        guidePrice: 0,
        // 预付总计
        preTotalScaleStandard: 0,
        // 预付现金
        preCashScaleStandard: 0,
        // 预付油卡
        preOilVirtualScaleStandard: 0,
        // ETC
        preEtcScaleStandard: 0,
        // 预付金额
        preTotalFee: 0,
        // 预付金额比例
        preTotalScale: 0,
        // 金额
        preCashFee: 0,
        // 金额比例
        preCashScale: 0,
        // 虚拟油
        preOilVirtualFee: 0,
        // 虚拟油比例
        preOilVirtualScale: 0,
        // 实体油
        preOilFee: 0,
        // 实体油比例
        preOilScale: 0,
        // ETC金额
        preEtcFee: 0,
        // ETC金额比例
        preEtcScale: 0,
        // 到付金额
        arrivePaymentFee: 0,
        // 到付金额比例
        arrivePaymentFeeScale: 0,
        // 尾款金额
        finalFee: 0,
        // 尾款金额比例
        finalScale: 0,
        // 现金
        finalCashFee: 0,
        // 保费
        insuranceFee: 0,
      },
    };
  },
  computed: {
    isExternalFreight () {
      return (Number(this.dispatchInfo.appointWay) === 3 && Number(this.dispatchInfo.vehicleClass) !== 1) || Number(this.dispatchInfo.appointWay) === 5;
    },
    isContractPaymentWay () {
      return Number(this.dispatchInfo.appointWay) === 3 && Number(this.dispatchInfo.vehicleClass) === 1 && Number(this.dispatchInfo.paymentWay) === 3;
    },
  },
  methods: {
    async getDataTest () {
      // console.log('承包模式参数', this.getFormsValue());
    },
    // 调用 getLevel 接口，然后设置各种比例
    async getLevelAndSetSomeScales (vehicleClass, contractFormData) {
      if (contractFormData) {
        // 如果之前有操作缓存数据，证明是之前已经请求过，直接使用缓存
        this.setFormVal(this.dispatchInfo, contractFormData);
        // 分配油来源
        let oilAccountType = '1';
        if (isExist(this.dispatchInfo.oilAccountType)) {
          oilAccountType = String(this.dispatchInfo.oilAccountType);
        }
        this.$refs.baseForm.setVal('oilAccountType', oilAccountType);
      } else {
        // 如果之前没有缓存，则重新请求
        this.dispatchInfo.vehicleClass = vehicleClass || this.dispatchInfo.vehicleClass || 3;
        const data = await getLevel({
          vehicleClass: this.dispatchInfo.vehicleClass,
        });

        this.dispatchInfo.feeList = data.feeList;

        // 预付总计 上限比例标准，显示百分比 * 100
        this.dispatchInfo.preTotalScaleStandard = isExist(data.advanceCharge) ? (data.advanceCharge) : 0;
        // 预付虚拟油卡（预付油卡） 比例标准，显示百分比 * 100
        this.dispatchInfo.preOilVirtualScaleStandard = isExist(data.oilScale) ? (data.oilScale) : 0;
        // 预付油卡比例标准
        this.dispatchInfo.preOilScaleStandard = 0;
        // 预付ETC 比例标准，显示百分比 * 100
        this.dispatchInfo.preEtcScaleStandard = isExist(data.etcScale) ? (data.etcScale) : 0;

        if (this.dispatchInfo.vehicleClass !== 1) {
          this.dispatchInfo.preEtcScaleStandard = 0;
        }
        // 预付现金 比例标准，显示百分比 * 100
        this.dispatchInfo.preCashScaleStandard = this.dispatchInfo.preTotalScaleStandard - this.dispatchInfo.preOilVirtualScaleStandard - this.dispatchInfo.preEtcScaleStandard;

        // 初始化实际比例  比例显示：百分比 * 100
        // 预付总计上限比例值
        this.dispatchInfo.preTotalScale = this.dispatchInfo.preTotalScaleStandard * 100;

        // 初始化到付比例
        this.dispatchInfo.arrivePaymentFeeScale = 0;
        // 预付尾款比例值
        this.dispatchInfo.finalScale = 1 - this.dispatchInfo.preTotalScaleStandard;
        this.dispatchInfo.finalScale = Number((this.dispatchInfo.finalScale * 100).toFixed(2));

        // 预付现金比例 显示值 比例显示：百分比 * 100
        this.dispatchInfo.preCashScale = (this.dispatchInfo.preTotalScaleStandard - this.dispatchInfo.preOilVirtualScaleStandard - this.dispatchInfo.preEtcScaleStandard) * 100;
        // 预付虚拟油卡比例 显示值 比例显示：百分比 * 100
        this.dispatchInfo.preOilVirtualScale = this.dispatchInfo.preOilVirtualScaleStandard * 100;
        // 预付油卡比例  显示值 比例显示：百分比 * 100
        this.dispatchInfo.preOilScale = this.dispatchInfo.preOilScaleStandard * 100;
        // 预付ETC比例  显示值 比例显示：百分比 * 100
        this.dispatchInfo.preEtcScale = this.dispatchInfo.preEtcScaleStandard * 100;

        this.dispatchInfo.paymentDays = isExist(data.paymentDay) ? data.paymentDay : 0;

        if (JSON.stringify(data) === '{}') {
          this.dispatchInfo.guidePrice = 0;
        }
      }

    },
    // 更改中标价/承包价
    async totalFeeChange () {
      if (!isExist(this.dispatchInfo.totalFee)) {
        this.dispatchInfo.totalFee = 0;
      }
      this.scaleUpdate('CASH');
      this.scaleUpdate('VIRTUAL');
      this.scaleUpdate('OIL');
      this.scaleUpdate('ETC');
      this.scaleUpdate('ARRIVE_CASH');
      if (this.isExternalFreight) {
        // 获取最高中标价
        const res = await getAmountLimitCfgVal();
        if (isExist(res)) {
          this.dispatchInfo.maxAmount = (Number(res) / 100.0).toFixed(2);
        }
        if (isExist(this.dispatchInfo.maxAmount)) {
          if (this.dispatchInfo.totalFee > this.dispatchInfo.maxAmount && this.dispatchInfo.maxAmount >= 0) {
            this.$message({
              type: 'warning',
              message: `外调车运费不能超过${this.dispatchInfo.maxAmount}元`,
            });
          }
        }
      }
    },
    // 比例修改
    scaleUpdate (type) {
      let totalFee = this.dispatchInfo.totalFee;
      totalFee = isExist(totalFee) && !isNaN(totalFee) ? totalFee : 0;
      this.dispatchInfo.totalFee = Number(totalFee);

      if (type === 'CASH') {
        let preCashScale = this.dispatchInfo.preCashScale;
        preCashScale = isExist(preCashScale) && !isNaN(preCashScale) ? preCashScale : 0;

        this.dispatchInfo.preCashFee = Number(preCashScale) * totalFee / 100.0;
        if (isTwoBitDecimal(this.dispatchInfo.preCashFee)) {
          this.dispatchInfo.preCashFee = Math.round(this.dispatchInfo.preCashFee * 100) / 100;
          preCashScale = (this.dispatchInfo.preCashFee / totalFee) * 100;
          if (isTwoBitDecimal(preCashScale)) {
            preCashScale = Math.round(preCashScale * 100) / 100;
          }
        }
        preCashScale = Number(Number(preCashScale).toFixed(2));
        this.dispatchInfo.preCashScale = preCashScale;
      }
      if (type === 'VIRTUAL') {
        // 是否需要发票
        let preOilVirtualScale = this.dispatchInfo.preOilVirtualScale;
        preOilVirtualScale = isExist(preOilVirtualScale) && !isNaN(preOilVirtualScale) ? preOilVirtualScale : 0;
        let preOilVirtualFee = preOilVirtualScale * totalFee / 100;

        if (isTwoBitDecimal(preOilVirtualFee)) {
          preOilVirtualFee = Math.round(preOilVirtualFee * 100) / 100;
          preOilVirtualScale = preOilVirtualFee / totalFee * 100;
          if (isTwoBitDecimal(preOilVirtualScale)) {
            preOilVirtualScale = Math.round(preOilVirtualScale * 100) / 100;
          }
        }
        preOilVirtualFee = Number(Number(preOilVirtualFee).toFixed(2));
        preOilVirtualScale = Number(Number(preOilVirtualScale).toFixed(2));
        this.dispatchInfo.preOilVirtualFee = preOilVirtualFee;
        this.dispatchInfo.preOilVirtualScale = preOilVirtualScale;

        this.oilAccountTypeChange();
      }
      if (type === 'OIL') {
        let preOilScale = this.dispatchInfo.preOilScale;
        preOilScale = isExist(preOilScale) && !isNaN(preOilScale) ? preOilScale : 0;
        let preOilFee = preOilScale * totalFee / 100.0;
        if (isTwoBitDecimal(preOilFee)) {
          preOilFee = Math.round(preOilFee * 100) / 100;
          preOilScale = preOilFee / totalFee * 100;
          if (isTwoBitDecimal(preOilScale)) {
            preOilScale = Math.round(preOilScale * 100) / 100;
          }
        }
        preOilFee = Number(Number(preOilFee).toFixed(2));
        preOilScale = Number(Number(preOilScale).toFixed(2));
        this.dispatchInfo.preOilScale = preOilScale;
        this.dispatchInfo.preOilFee = preOilFee;
      }
      if (type === 'ETC') {
        let preEtcScale = this.dispatchInfo.preEtcScale;
        preEtcScale = isExist(preEtcScale) && !isNaN(preEtcScale) ? preEtcScale : 0;
        let preEtcFee = preEtcScale * totalFee / 100;
        if (isTwoBitDecimal(preEtcFee)) {
          preEtcFee = Math.round(preEtcFee * 100) / 100;
          preEtcScale = preEtcFee / totalFee * 100;
          if (isTwoBitDecimal(preEtcScale)) {
            preEtcScale = Math.round(preEtcScale * 100) / 100;
          }
        }
        preEtcFee = Number(Number(preEtcFee).toFixed(2));
        preEtcScale = Number(Number(preEtcScale).toFixed(2));
        this.dispatchInfo.preEtcScale = preEtcScale;
        this.dispatchInfo.preEtcFee = preEtcFee;
      }
      if (type === 'ARRIVE_CASH') {
        let arrivePaymentFeeScale = this.dispatchInfo.arrivePaymentFeeScale;
        arrivePaymentFeeScale = isExist(arrivePaymentFeeScale) && !isNaN(arrivePaymentFeeScale) ? arrivePaymentFeeScale : 0;
        let arrivePaymentFee = arrivePaymentFeeScale * totalFee / 100;
        if (isTwoBitDecimal(arrivePaymentFee)) {
          arrivePaymentFee = Math.round(arrivePaymentFee * 100) / 100;
          arrivePaymentFeeScale = arrivePaymentFee / totalFee * 100;
          if (isTwoBitDecimal(arrivePaymentFeeScale)) {
            arrivePaymentFeeScale = Math.round(arrivePaymentFeeScale * 100) / 100;
          }
        }
        arrivePaymentFee = Number(Number(arrivePaymentFee).toFixed(2));
        arrivePaymentFeeScale = Number(Number(arrivePaymentFeeScale).toFixed(2));
        this.dispatchInfo.arrivePaymentFeeScale = arrivePaymentFeeScale;
        this.dispatchInfo.arrivePaymentFee = arrivePaymentFee;
      }

      // 设置预付款和尾款
      this.setPreFeeAndFinalFee();
      // 设置尾款金额的现金
      this.setFinalCashFee();

      if (this.dispatchInfo.oldInsuranceFee !== null && this.dispatchInfo.oldInsuranceFee >= 0) {
        this.dispatchInfo.finalCashFee = Number((this.dispatchInfo.finalFee - this.dispatchInfo.oldInsuranceFee).toFixed(2));
      } else if (isExist(this.dispatchInfo.finalFee) && !isNaN(this.dispatchInfo.finalFee)) {
        this.setInsuranceFee();
      }
      /* eslint-enable */
    },
    // 金额更改
    /* eslint-disable */
    feeUpdate (type) {
      let totalFee = this.dispatchInfo.totalFee;
      totalFee = isExist(totalFee) && !isNaN(totalFee) ? totalFee : 0;
      if (type === 'CASH') {
        let preCashFee = this.dispatchInfo.preCashFee;
        let preCashScale = this.dispatchInfo.preCashScale;
        preCashFee = isExist(preCashFee) && !isNaN(preCashFee) ? preCashFee : 0;
        if (totalFee !== 0) {
          preCashScale = preCashFee / totalFee * 100;
        } else {
          preCashScale = 0;
          preCashFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preCashScale)) {
          preCashScale = Math.round(preCashScale * 100) / 100;
        }

        this.dispatchInfo.preCashFee = parseFloat(preCashFee);
        this.dispatchInfo.preCashScale = parseFloat(preCashScale);
      }
      if (type === 'VIRTUAL') {
        let preOilVirtualFee = this.dispatchInfo.preOilVirtualFee;
        preOilVirtualFee = isExist(preOilVirtualFee) && !isNaN(preOilVirtualFee) ? preOilVirtualFee : 0;

        let preOilVirtualScale = this.dispatchInfo.preOilVirtualScale;
        if (totalFee !== 0) {
          preOilVirtualScale = this.dispatchInfo.preOilVirtualFee / totalFee * 100;
        } else {
          preOilVirtualScale = 0;
          preOilVirtualFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preOilVirtualScale)) {
          preOilVirtualScale = Math.round(preOilVirtualScale * 100) / 100;
        }
        this.dispatchInfo.preOilVirtualFee = parseFloat(preOilVirtualFee);
        this.dispatchInfo.preOilVirtualScale = parseFloat(preOilVirtualScale);

        this.oilAccountTypeChange();
      }
      if (type === 'OIL') {
        let preOilFee = this.dispatchInfo.preOilFee;
        preOilFee = isExist(preOilFee) && !isNaN(preOilFee) ? preOilFee : 0;
        let preOilScale = this.dispatchInfo.preOilScale;
        if (totalFee !== 0) {
          preOilScale = this.dispatchInfo.preOilFee / totalFee * 100;
        } else {
          preOilScale = 0;
          preOilFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preOilScale)) {
          preOilScale = Math.round(preOilScale * 100) / 100;
        }
        this.dispatchInfo.preOilFee = parseFloat(preOilFee);
        this.dispatchInfo.preOilScale = parseFloat(preOilScale);
      }
      if (type === 'ETC') {
        let preEtcFee = this.dispatchInfo.preEtcFee;
        preEtcFee = isExist(preEtcFee) && !isNaN(preEtcFee) ? preEtcFee : 0;
        let preEtcScale = this.dispatchInfo.preEtcScale;
        if (totalFee !== 0) {
          preEtcScale = preEtcFee / totalFee * 100;
        } else {
          preEtcScale = 0;
          preEtcFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(preEtcScale)) {
          preEtcScale = Math.round(preEtcScale * 100) / 100;
        }
        this.dispatchInfo.preEtcFee = parseFloat(preEtcFee);
        this.dispatchInfo.preEtcScale = parseFloat(preEtcScale);
      }
      if (type === 'ARRIVE_CASH') {
        let arrivePaymentFee = this.dispatchInfo.arrivePaymentFee;
        arrivePaymentFee = isExist(arrivePaymentFee) && !isNaN(arrivePaymentFee) ? arrivePaymentFee : 0;
        let arrivePaymentFeeScale = this.dispatchInfo.arrivePaymentFeeScale;
        if (totalFee !== 0) {
          arrivePaymentFeeScale = arrivePaymentFee / totalFee * 100;
        } else {
          arrivePaymentFeeScale = 0;
          arrivePaymentFee = 0;
        }
        // 三位小数以上，处理成两位小数
        if (isTwoBitDecimal(arrivePaymentFeeScale)) {
          arrivePaymentFeeScale = Math.round(arrivePaymentFeeScale * 100) / 100;
        }
        this.dispatchInfo.arrivePaymentFee = parseFloat(arrivePaymentFee);
        this.dispatchInfo.arrivePaymentFeeScale = parseFloat(arrivePaymentFeeScale);
      }

      // 设置预付款和尾款
      this.setPreFeeAndFinalFee();
      // 设置尾款金额的现金
      this.setFinalCashFee();

      // 设置保费
      if (this.dispatchInfo.oldInsuranceFee !== null && this.dispatchInfo.oldInsuranceFee >= 0) {
        this.dispatchInfo.finalCashFee = Number((this.dispatchInfo.finalFee - this.dispatchInfo.oldInsuranceFee).toFixed(2));
      } else {
        this.setInsuranceFee();
      }
    },
    // 设置尾款金额的现金
    setFinalCashFee () {
      this.dispatchInfo.finalCashFee = this.dispatchInfo.finalFee - this.dispatchInfo.insuranceFee;
    },
    /* eslint-enable */
    // 分配油来源变化
    oilAccountTypeChange () {
      this.$emit('checkOilAccount');
    },
    // 设置预付款和尾款
    setPreFeeAndFinalFee () {
      /* eslint-disable */
      this.dispatchInfo.preTotalScale = Number((this.dispatchInfo.preCashScale - 0 + this.dispatchInfo.preOilVirtualScale - 0 + this.dispatchInfo.preOilScale - 0 + this.dispatchInfo.preEtcScale).toFixed(2));
      this.dispatchInfo.preTotalFee = this.dispatchInfo.preCashFee - 0 + this.dispatchInfo.preOilVirtualFee - 0 + this.dispatchInfo.preOilFee - 0 + this.dispatchInfo.preEtcFee;

      if (isTwoBitDecimal(this.dispatchInfo.preTotalFee)) {
        this.dispatchInfo.preTotalFee = Math.round(this.dispatchInfo.preTotalFee * 100) / 100;
      }

      // 尾款
      this.dispatchInfo.finalScale = ((100 - this.dispatchInfo.preTotalScale - this.dispatchInfo.arrivePaymentFeeScale)).toFixed(2);
      this.dispatchInfo.finalFee = Number((this.dispatchInfo.totalFee - this.dispatchInfo.preTotalFee - this.dispatchInfo.arrivePaymentFee).toFixed(2));
      /* eslint-enable */
    },
    // 设置保费
    setInsuranceFee () {
      let isContain = false;
      if (!this.dispatchInfo.feeList) {
        this.getLevelAndSetSomeScales();
        return;
      }
      if (isExist(this.dispatchInfo.feeList) && isExist(this.dispatchInfo.totalFee)) {
        let totalFee = this.dispatchInfo.totalFee * 100;
        for (let i = 0; i < this.dispatchInfo.feeList.length; i++) {
          let obj = this.dispatchInfo.feeList[i];
          if (obj.maxFee !== -1) {
            if (((i === 0 && totalFee >= obj.minFee) || (totalFee > obj.minFee && i > 0)) && totalFee <= obj.maxFee) {
              this.dispatchInfo.insuranceFee = obj.insuranceFee / 100.0;
              this.dispatchInfo.finalCashFee = Number((this.dispatchInfo.finalFee - this.dispatchInfo.insuranceFee).toFixed(2));
              isContain = true;
            }
          } else {
            if (totalFee > obj.minFee) {
              this.dispatchInfo.insuranceFee = Number((obj.insuranceFee / 100.0).toFixed(2));
              this.dispatchInfo.finalCashFee = Number(Number(this.dispatchInfo.finalFee - this.dispatchInfo.insuranceFee).toFixed(2));
              isContain = true;
            }
          }
        }
      }

      if (!isContain) {
        this.dispatchInfo.insuranceFee = 0;
        this.dispatchInfo.finalCashFee = Number(Number(this.dispatchInfo.finalFee).toFixed(2));
      }
    },
    // 缓存数据，当页面来回切换的时候 diapatch 和 assignVehicle 组件会调用
    cacheData () {
      if (this.$refs.baseForm) {
        const oilAccountType = this.$refs.baseForm.getVal('oilAccountType');
        this.dispatchInfo.oilAccountType = oilAccountType;
      }
      return this.dispatchInfo;
    },
    // 获取所以需要提交的参数
    sub () {
      if (this.$refs.baseForm) {
        const oilAccountType = this.$refs.baseForm.getVal('oilAccountType');
        this.dispatchInfo.oilAccountType = oilAccountType;
      }

      // 避免最后提交出现异常，删除外面已使用或者只用来显示的参数
      delete this.dispatchInfo.vehicleClass;
      delete this.dispatchInfo.appointWay;
      delete this.dispatchInfo.isNeedBill;
      delete this.dispatchInfo.paymentWay;
      delete this.dispatchInfo.feeList;
      // delete this.dispatchInfo.feeTitle;
      return this.dispatchInfo;
    },
    // 这个方法不知道干嘛的，抄过来的
    setPreOilFee () {
      // TODO
    },
  },
  watch: {
    isNeedBill (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dispatchInfo.isNeedBill = Number(newValue);
        this.setPreOilFee();
      }
    },
    paymentWay (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dispatchInfo.paymentWay = Number(newValue);
      }
    },
    appointWay (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.dispatchInfo.appointWay = Number(newValue);
        if (this.dispatchInfo.appointWay === 5 || this.dispatchInfo.appointWay === 3) {
          this.setPreOilFee();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calc-box-container {
  display: flex;
  align-items: center;
  .text-box {
    font-size: 14px;
    border: 1px solid #ededed;
    border-radius: 2px;
    border-radius: 2px;
    padding: 10px;
    display: flex;
    &:nth-of-type(2) {
      margin-top: -1px;
    }
    &.f-dir-r {
      flex-direction: row;
    }
    &.f-dir-c {
      flex-direction: column;
    }
    &.jc-center {
      justify-content: center;
    }
    &.ai-center {
      align-items: center;
    }
    .label {
      color: #333333;
    }
    &:first-child {
      .value {
        color: #ff5046;
        .calc-chart-ipt {
          color: #ff5046;
        }
      }
    }
    .value {
      display: flex;
      .calc-chart-ipt {
        width: 44px;
        border: none;
        outline: none;
        &:only-child {
          width: 50px;
        }
      }
    }
  }

  .calc-box-left {
    max-width: 96px;
    padding: 5px 10px;
    .text-box {
      .label {
        padding-bottom: 4px;
      }
      .value {
        .calc-chart-ipt {
          width: 100%;
          margin-right: 0;
          text-align: center;
        }
      }
    }
  }
  .calc-box-separate {
    width: 9px;
    height: 194px;
    margin-left: 26px;
    position: relative;
    border: 1px solid #ededed;
    border-right: none;
    &:before {
      position: absolute;
      content: " ";
      width: 0;
      height: 0;
      border-top: 7.5px solid transparent;
      border-right: 8px rgba(224, 233, 243, 1) solid;
      border-bottom: 7.5px solid transparent;
      top: 50%;
      left: -8px;
    }
    &:after {
      position: absolute;
      content: " ";
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 9px #fff solid;
      border-bottom: 6px solid transparent;
      top: 50%;
      left: -7px;
      z-index: 2;
    }
  }
  .calc-box-right {
    display: flex;
    flex-direction: column;
    .row-title {
      margin-bottom: 14px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      :first-child {
        width: 174px;
      }
      :nth-last-child(1) {
        width: 180px;
        text-align: right;
      }
      :nth-last-child(2) {
        width: 300px;
        text-align: center;
      }
    }
    .calc-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 24px;
      &:nth-of-type(2) {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 30px;
      }
      .row-label {
        margin-left: 12px;
        margin-right: 24px;
      }
      .row-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        .row-box {
          // width: 120px;
          .text-box {
            &:only-child {
              height: 81px;
              box-sizing: border-box;
            }
            &:nth-of-type(2) {
              margin-top: -1px;
            }
            .label {
              width: 52px;
            }
          }
        }
        .row-symbol {
          font-size: 30px;
          color: #bcbbbb;
          margin: 0 22px;
        }
      }
    }
  }
}
</style>
